const getEnvironment = () => {
  switch (window.GTM_CONTAINER_ID) {
    case 'GTM-53RVSND':
      return 'development';
    case 'GTM-T36WQ7B':
      return 'UAT';
    case 'GTM-WQV3887':
      return 'production';
    default:
      return 'development';
  }
};

export default getEnvironment;
